var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createElement, useMemo } from 'react';
import styles from './typography.module.scss';
import { classNames } from '../../utils';
import { useClassNames } from '../../hooks/use-class-names';
export var Text = function (_a) {
    var _b = _a.tag, tag = _b === void 0 ? '' : _b, className = _a.className, children = _a.children, _c = _a.cfg, cfg = _c === void 0 ? {} : _c, props = __rest(_a, ["tag", "className", "children", "cfg"]);
    var tagClassName = useMemo(function () { return styles[tag]; }, [tag]);
    var classNames = useClassNames(cfg, [tagClassName, className]);
    return createElement(tag, __assign({ className: classNames }, props), children);
};
export var H1 = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Text, __assign({ tag: "h1" }, props));
};
export var H2 = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Text, __assign({ tag: "h2" }, props));
};
export var H3 = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Text, __assign({ tag: "h3" }, props));
};
export var H4 = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Text, __assign({ tag: "h4" }, props));
};
export var H5 = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Text, __assign({ tag: "h5" }, props));
};
export var H6 = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Text, __assign({ tag: "h6" }, props));
};
export var P = function (_a) {
    var testid = _a.testid, props = __rest(_a, ["testid"]);
    return React.createElement(Text, __assign({ tag: "p", "data-testid": testid }, props));
};
export var Span = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Text, __assign({ tag: "span" }, props));
};
export var B = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Text, __assign({ tag: "b", className: classNames([styles.bold, className]) }, props)));
};
export var Hr = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Text, __assign({ tag: "hr", className: classNames([styles.hr, className]) }, props)));
};
//# sourceMappingURL=typography.js.map